import { SharingSchedule } from "modules/sharing";

const SharingSchedulePage = () => {
  return <SharingSchedule />;
};

export default SharingSchedulePage;
